const ROLE_1_FORCED_START_TIME = 'role1ForcedStartTime';
export default ROLE_1_FORCED_START_TIME;
